import { FC, useState } from "react";
import classes from './tutorCalendar.module.scss'
import { LoaderSpinner } from "../../../../shared/ui/spinner";
import { ITutorFinance, tutorService } from "../../../../entities/tutor";
import { Calendar } from "../../../../shared/ui/calendar";
import { FEATURES, hasFeature, useMyActions } from "../../../../entities/my";
import { useGlobalMessageActions } from "../../../../entities/globalMessage";
import { MyError } from "../../../../shared/lib/error/MyError";
import { AuthError } from "../../../../shared/lib/error/AuthError";
import { getDateUTC } from "../../../../shared/lib/helpers/getDateUTC";
import { useAppSelector } from "../../../../app/store/store";

interface IProps {
    id: number;
    userId?: number;
}

export const TutorCalendar: FC<IProps> = ({id, userId}) => {

    const [finance, setFinance] = useState<ITutorFinance | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const {my} = useAppSelector(s => s.myReducer)
    const {setIsAuth} = useMyActions()
    const {setGlobalMessage} = useGlobalMessageActions()

    const getData = async (startDate: string, endDate: string) => {
        try{
            setIsLoading(true)
            const financeRes = userId && userId > 0
                ? await tutorService.getFinanceByUserId(userId, startDate, endDate)
                : await tutorService.getFinance(id, startDate, endDate)
            setFinance(financeRes)
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при получении данных', type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }

    const setDate = (startDate: Date | null, endDate: Date | null) => {
        if(startDate && endDate){
            getData(getDateUTC(startDate), getDateUTC(endDate))
        }
        if(!startDate && !endDate){
            setFinance(null)
        }
    }

    return (
        <section className={classes.container}>
            <Calendar
                onDateRangeSelect={setDate} 
                isLoading={isLoading}
            />
            {
                isLoading
                    ?
                <section className={classes.loader}><LoaderSpinner /></section>
                    :
                finance
                    &&
                <section className={classes.data}>
                    <section className={classes.sub}>Исполнитель</section>
                    <span>Количество часов: {finance.hoursCount}</span>
                    <span>Вознаграждение: {finance.wages} ₽</span>
                    {
                        hasFeature(my, FEATURES.FINANCE.VIEW_FULL)
                            &&
                        <>
                            <section className={classes.sub}>Общее</section>
                            <span>Прибыль: {finance.amount} ₽</span>
                        </>
                    }
                </section>
            }
        </section>
    )
}
